// @ts-check

import { api } from '@/api'

export const setPaymentTerminalAuthCode = async (state, code) =>
  api.post('payment-terminals/auth-code', { state, code })

/**
 * @returns {Promise<PaymentTerminal[]>}
 */
export const getPaymentTerminalIntegrations = async () => {
  const { data: paymentTerminals } = await api.get('payment-terminals')
  return paymentTerminals
}

/**
 * @param {PaymentTerminalName} integration
 * @returns {Promise<string>}
 */
export const getPaymentTerminalIntegrationAuthUrl = async (integration) => {
  /** @type {import('axios').AxiosResponse & { url: string }} */
  const data = await api.get(`payment-terminals/get-auth-url/${integration}`)
  return data.url
}
